import { UPDATE_CURRENT_LANGUAGE } from "./action-types"

export const updateCurrentLanguage = currentLang => {
  return {
      type: UPDATE_CURRENT_LANGUAGE,
      payload: {
          currentLang
      }
  }
}